import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import { setAuthUserDataLoading, setAuthUserData } from "../redux/login";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { useParams, useSearchParams } from "react-router-dom";
import agentAxios from "../lib/AxiosInterceptor";
import {
  setListOfAppointments,
  setListOfAppointmentsError,
  setListOfAppointmentsLoading,
  setMyPropertyVisitsListLoading,
  setMyPropertyVisitsListError,
  setMyPropertyVisitsList,
} from "../redux/agentDashboard";
export const schedulePropertyVisit = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await axios.post(
        `${ApiConfig.schedulePropertyVisit}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        // localStorage.removeItem("token");
        // localStorage.removeItem("user");
        toast.success(
          `Congratulations! You Have Successfully Scheduled Your Visit.`,
          {
            autoClose: 2500,
            className: "toast-message",
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        return true;
        // dispatch(setAuthUserDataLoading(false));
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};
export const schedulePropertyVisitAgentAudit = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await agentAxios.post(
        `${ApiConfig.schedulePropertyAudit}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        // localStorage.removeItem("token");
        // localStorage.removeItem("user");
        toast.success(
          `Congratulations! You Have Successfully Scheduled Your Visit.`,
          {
            autoClose: 2500,
            className: "toast-message",
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        return true;
        // dispatch(setAuthUserDataLoading(false));
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};
export const getTimeSlotsService = async (extraConfig) => {
  try {
    const response = await axios.get(`${ApiConfig.getTimeSlots}`);
    if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
      return response?.data?.data;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
    return null;
  }
};

export const getAgentTimeSlotsService = async () => {
  try {
    const response = await agentAxios.get(`${ApiConfig.getTimeSlots}`);
    if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
      return response?.data?.data;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
    return null;
  }
};

export const propertyScheduleRequestApproval = async (payload, extraConfig) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.propertyVisitRequestAccept}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  }
};

export const GetPropertyAuditAppointmentsList = (currentPage, currentPageLimit) => {
  return async (dispatch) => {
    try {
      dispatch(setListOfAppointmentsLoading(true));
      const resp = await agentAxios.get(`${ApiConfig.scheduleAuditList}${
        currentPage ? `?page=${currentPage}` : ""
      }${
        currentPageLimit
          ? `${currentPage ? "&" : "?"}limit=${currentPageLimit}`
          : ""
      }`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setListOfAppointments(resp?.data?.data));

        dispatch(setListOfAppointmentsLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setListOfAppointmentsError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setListOfAppointmentsLoading(false));
    }
  };
};

export const GetMyPropertyVisitsList = (currentPage, currentPageLimit) => {
  return async (dispatch) => {
    try {
      dispatch(setMyPropertyVisitsListLoading(true));
      const resp = await agentAxios.get(`${ApiConfig.scheduleVisitList}${
        currentPage ? `?page=${currentPage}` : ""
      }${
        currentPageLimit
          ? `${currentPage ? "&" : "?"}limit=${currentPageLimit}`
          : ""
      }`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setMyPropertyVisitsList(resp?.data?.data));
        dispatch(setMyPropertyVisitsListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setMyPropertyVisitsListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setMyPropertyVisitsListLoading(false));
    }
  };
};
